// @ts-nocheck
/* eslint-disable */
import Reorder from '~/lib/reorder';

/*
* Vyuziva route.form pro pretahovani prujezdnich bodu
* ve formulari a my.visualizer pro sortovani oblibenych
*/
export default class RouteReorder extends Reorder {
	/**
	 * @param {node || string} container id nebo reference kontejneru, obsahujiciho prohazovaci prvky
	 * @param {object} [optObj] asociativni pole parametru
	 * @param {string} [optObj.handleClass] CSS trida k elementu, za ktery se ma chytat. Pokud je false (default), taha se za cely node
	 * @param {string} [optObj.ghostProcess] Volitelny callback na zprocessovani vzhledu ducha
	 * @param {int} [optObj.scrollSpeed] Rychlost scrollovani rodice, pokud jsme u jeho okraje. 0 = nescrollovat.
	 */
	constructor(container, optObj, cb) {
		super(container, optObj);
		this._cb = cb;
		this._clickData = {
			x: -1,
			y: -1,
			target: null
		};
		this._enabled = true;
	};

	/**
	 * Povoleni/zakazani DAD.
	 *
	 * @param   {Boolean}  state
	 */
	setEnable(state) {
		this._enabled = state;
	}

	/**
	 * Vyvolani eventu.
	 *
	 * @param   {String}  name Nazev eventu
	 * @param   {Object}  data
	 */
	_makeEvent(name, data) {
		if (typeof this._cb === "function") {
			this._cb(name, data);
		}
	}

	_mouseMove(e, elm) {
		if (!this._dragging) { return; }
		if (!this._appended) { /* append ghost */
			this._appended = true;
			document.getElementById("mapycz").appendChild(this._dom.ghost);
			/* schovam pretahovany prvek at nerusi */
			this._itemDragged.getContainer().style.visibility = "hidden";
			var i = 0;
			this._items.forEach(function(item) {
				var el = item.getContainer();

				if (el.classList.contains("route-item-point") || el.classList.contains("route-item-empty")) {
					el.setAttribute("data-ind", i);
					i++;
				}
			}, this);
		}

		e.preventDefault();

		var dx = e.clientX - this.clientX;
		var dy = e.clientY - this.clientY;
		this.clientX = e.clientX;
		this.clientY = e.clientY;

		this._refresh(dx, dy);
	}

	_refresh(dx, dy) {
		var g = this._dom.ghost;

		/* move ghost */
		if (this._options.direction.indexOf("x") != -1) {
			this.ghostX += dx;
			g.style.left = this.ghostX+"px";
		}
		if (this._options.direction.indexOf("y") != -1) {
			this.ghostY += dy;
			g.style.top = this.ghostY+"px";
		}

		/* test position */
		var above = this._getAbove();


		if (above && above != this._itemAbove) {
			/* aktualizuji dom pretahovanych prvku */
			this._updateDraggedPosition(above);
			above._addActive();
			this._itemAbove = above;
		}
	}

	_getAbove() {
		var x = this.ghostX + this._dom.ghost.offsetWidth/2;
		var y = this.ghostY + this._dom.ghost.offsetHeight/2;

		var scroll = JAK.DOM.getScrollPos();
		for (var i = 0; i < this._items.length; i++) {
			var item = this._items[i];
			if (this._items.length > 2 && (!item.getContainer().classList.contains("route-item-point") && !item.getContainer().classList.contains("route-item-empty"))) { continue; }
			var pos = JAK.DOM.getPortBoxPosition(item.getContainer());
			pos.left += scroll.x;
			pos.top += scroll.y;
			var w = item.getContainer().offsetWidth;
			var h = item.getContainer().offsetHeight;
			var ok_x = true;
			var ok_y = true;
			if (this._options.direction.indexOf("x") != -1) { ok_x = x >= pos.left && x <= pos.left+w; }
			if (this._options.direction.indexOf("y") != -1) { ok_y = y >= pos.top && y <= pos.top+h; }
			if (ok_x && ok_y) { return item; }
		}
		return false;
	}

	_mouseUp(e, elm) {
		if (!this._dragging) { return; }
		this._dragging = false;

		let el = this._itemDragged.getContainer();
		let dragIndex = parseInt(el.getAttribute("data-ind"));

		if (this._interval) { /* uz nekoukame */
			clearInterval(this._interval);
			this._interval = null;
		}
		/* pretahovany prvek zobrazim na spravnem miste */
		this._itemDragged.getContainer().style.visibility = "visible";

		var reorderIndexes = [];

		this._items.forEach(function(item) {
			//item._removeActive();
			var el = item.getContainer();
			var ind = el.getAttribute("data-ind");
			if (ind) {
				reorderIndexes.push(parseFloat(ind));
			}
			el.removeAttribute("data-ind");
		}, this);

		if (this._itemAbove) { this._itemAbove._removeActive(); }

		if (!this._dom.ghost || !this._dom.ghost.parentNode) {
			if (this._clickData.target) {
				let diffX = e.clientX - this._clickData.x;
				let diffY = e.clientY - this._clickData.y;
				let threshold = 3;

				if (Math.abs(diffX) < threshold && Math.abs(diffY) < threshold) {
					this._makeEvent("item-click", { el: this._clickData.target });
					return;
				}
			}

			this._makeEvent("end-dragging", null);
			return;
		}
		this._dom.ghost.remove();
		this._appended = false;

		if (!this._itemAbove || dragIndex == reorderIndexes.indexOf(dragIndex)) {
			this._makeEvent("end-dragging", null);
			return;
		} /* no repositioning */
		this._makeEvent("end-dragging", {
			ind: dragIndex,
			value: reorderIndexes.indexOf(dragIndex)
		});
	}

	_updateDraggedPosition(active) {
		/* aktualizuji strom pretahovanych prvku */
		var itemNode = this._itemDragged.getContainer();
		var activeNode = active.getContainer();
		var itemIndex = this._items.indexOf(this._itemDragged);
		var activeIndex = this._items.indexOf(active);
		//var plus = null;

		if (itemIndex == activeIndex) { return; }

		this._items.splice(itemIndex, 1); // odeberu tazenej
		this._items.splice(activeIndex, 0, this._itemDragged); // vlozim tazenej na novy index
		this._items.splice(activeIndex + (itemIndex < activeIndex ? -1 : 1), 1); // odeberu nahrazeny
		this._items.splice(itemIndex + (itemIndex < activeIndex ? 0 : 0), 0, active); // vlozim nahrazeny na novy index

		this._items.forEach(i => {
			this._dom.container.appendChild(i.getContainer());
		});

		this._itemDragged.getContainer().scrollIntoView({ behavior: "smooth", block: "nearest"});
	}

	_startDrag(item, e) {
		if (e.button == JAK.Browser.mouse.right || !this._enabled) { return; }
		this._clickData.x = e.clientX;
		this._clickData.y = e.clientY;
		this._clickData.target = e.target.closest(".route-item-point");
		Reorder.prototype._startDrag.call(this, item, e);
	}
}
